/*
 *
 * ReportHome actions
 *
 */

import {
  GET_STATUS_WATCHER,
  GET_STATUS_SUCCESS,
  GET_STATUS_FAILED,
  GET_DIMENSIONS_WATCHER,
  GET_DIMENSIONS_SUCCESS,
  GET_DIMENSIONS_FAILED,
  GET_DIVISIONS_WATCHER,
  GET_DIVISIONS_SUCCESS,
  GET_DIVISIONS_FAILED,
  GET_TEAMS_WATCHER,
  GET_TEAMS_SUCCESS,
  GET_TEAMS_FAILED,
  GET_QUALITATIVE_WATCHER,
  GET_QUALITATIVE_SUCCESS,
  GET_QUALITATIVE_FAILED,
  GET_RANKS_FAILED,
  GET_RANKS_SUCCESS,
  GET_RANKS_WATCHER,
  GET_MEASURE_COLOR_RANGE_WATCHER,
  GET_MEASURE_COLOR_RANGE_SUCCESS,
  GET_MULTIPLE_WATCHER,
  GET_MULTIPLE_SUCCESS,
  GET_MULTIPLE_FAILED,
  GET_MEASURE_INFO_WATCHER,
  GET_MEASURE_INFO_SUCCESS,
  GET_MEASURE_INFO_FAILED,
  GET_MULTIPLE_CHOICE_QUESTION_WATCHER,
  GET_MULTIPLE_CHOICE_QUESTION_SUCCESS,
  GET_MULTIPLE_CHOICE_QUESTION_FAILED,
  GET_QUALITATIVE_QUESTIONS_WATCHER,
  GET_QUALITATIVE_QUESTIONS_SUCCESS,
  GET_QUALITATIVE_QUESTIONS_FAILED,
  REFETCH_SENTIMENT_WORDCLOUD_WATCHER,
  DOWNLOAD_SENTIMENT_WORDCLOUD_WATCHER,
} from "./constants"

export function getStatusWatcher(payload) {
  return {
    type: GET_STATUS_WATCHER,
    payload,
  }
}

export function getStatusSuccess(payload) {
  return {
    type: GET_STATUS_SUCCESS,
    payload,
  }
}

export function getStatusFailed() {
  return { type: GET_STATUS_FAILED }
}

/* Divisions */
export function getDivisionsWatcher(payload) {
  return {
    type: GET_DIVISIONS_WATCHER,
    payload,
  }
}

export function getDivisionsSuccess(payload) {
  return {
    type: GET_DIVISIONS_SUCCESS,
    payload,
  }
}

export function getDivisionsFailed() {
  return { type: GET_DIVISIONS_FAILED }
}

/* Dimensions */
export function getDimensionsWatcher(payload) {
  return {
    type: GET_DIMENSIONS_WATCHER,
    payload,
  }
}

export function getDimensionsSuccess(payload) {
  return {
    type: GET_DIMENSIONS_SUCCESS,
    payload,
  }
}

export function getDimensionsFailed() {
  return { type: GET_DIMENSIONS_FAILED }
}

/* Questions */
export function getQualitativeWatcher(payload) {
  return {
    type: GET_QUALITATIVE_WATCHER,
    payload,
  }
}
export function getQualitativeQuestionsWatcher(payload) {
  return {
    type: GET_QUALITATIVE_QUESTIONS_WATCHER,
    payload,
  }
}
export function getQualitativeQuestionsSuccess(payload) {
  return {
    type: GET_QUALITATIVE_QUESTIONS_SUCCESS,
    payload,
  }
}

export function getQualitativeQuestionsFailed(payload) {
  return {
    type: GET_QUALITATIVE_QUESTIONS_FAILED,
    payload,
  }
}

export function getQualitativeSuccess(payload) {
  return {
    type: GET_QUALITATIVE_SUCCESS,
    payload,
  }
}

export function getQualitativeFailed() {
  return { type: GET_QUALITATIVE_FAILED }
}

/* multipleChoiceQuestions */
export function getMultipleWatcher(payload) {
  return {
    type: GET_MULTIPLE_WATCHER,
    payload,
  }
}

export function getMultipleSuccess(payload) {
  return {
    type: GET_MULTIPLE_SUCCESS,
    payload,
  }
}

export function getMultipleFailed() {
  return { type: GET_MULTIPLE_FAILED }
}

/* Divisions */
export function getTeamsWatcher(payload) {
  return {
    type: GET_TEAMS_WATCHER,
    payload,
  }
}

export function getTeamsSuccess(payload) {
  return {
    type: GET_TEAMS_SUCCESS,
    payload,
  }
}

export function getTeamsFailed() {
  return { type: GET_TEAMS_FAILED }
}

/* Ranks */
export function getRanksWatcher(payload) {
  return {
    type: GET_RANKS_WATCHER,
    payload,
  }
}

export function getRanksSuccess(payload) {
  return {
    type: GET_RANKS_SUCCESS,
    payload,
  }
}

export function getRanksFailed() {
  return { type: GET_RANKS_FAILED }
}

/* MEASURE RANGE COLOR */
export function getMeasureColorRangeWatcher(payload) {
  return {
    type: GET_MEASURE_COLOR_RANGE_WATCHER,
    payload,
  }
}

export function getMeasureColorRangeSuccess(payload) {
  return {
    type: GET_MEASURE_COLOR_RANGE_SUCCESS,
    payload,
  }
}

/* Measure Info */
export function getMeasureInfoWatcher(payload) {
  return {
    type: GET_MEASURE_INFO_WATCHER,
    payload,
  }
}

export function getMeasureInfoSuccess(payload) {
  return {
    type: GET_MEASURE_INFO_SUCCESS,
    payload,
  }
}

export function getMeasureInfoFailed() {
  return { type: GET_MEASURE_INFO_FAILED }
}

/* Multiple Choice Question */
export function getMultipleChoiceQuestionWatcher(payload) {
  return {
    type: GET_MULTIPLE_CHOICE_QUESTION_WATCHER,
    payload,
  }
}

export function getMultipleChoiceQuestionSuccess(payload) {
  return {
    type: GET_MULTIPLE_CHOICE_QUESTION_SUCCESS,
    payload,
  }
}

export function getMultipleChoiceQuestionFailed() {
  return { type: GET_MULTIPLE_CHOICE_QUESTION_FAILED }
}

/* Sentiment wordcloud (bubble chart) — refetch on-demand, ej. cambio de pregunta/división */
export function refetchSentimentWordcloudWatcher(payload) {
  return {
    type: REFETCH_SENTIMENT_WORDCLOUD_WATCHER,
    payload,
  }
}

/* Descarga del Excel de sentiment-wordcloud (botón "Descargar" en SentimentAnalysis) */
export function downloadSentimentWordcloudWatcher(payload) {
  return {
    type: DOWNLOAD_SENTIMENT_WORDCLOUD_WATCHER,
    payload,
  }
}
